import React, { useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ModalContext } from '../../context/ModalContext.js';
import fhfLogo from '../../images/fhf_logo.png';
import './PopupModal.css';

const PopupModal = () => {
    const { modals, closeModal, openModal } = useContext(ModalContext);

    const handleAboutClick = () => {
        closeModal('popup');
        openModal('about');
    };

    return (
        <Modal
            show={modals.popup}
            onHide={() => closeModal('popup')}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>About the Housing Policy Finder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <a target="_blank" rel="noreferrer" href="https://www.fhfund.org/">
                    <img src={fhfLogo} width="300" id="fhf_logo" alt=""/></a>      
                </div>
                
                <p>Throughout the seven-county Twin Cities region, jurisdictions are advancing housing agendas to meet the needs of the communities they serve. Local governments have an important role to play in promoting the optimal use of public resources, processes, and powers to support affordable homes, policies, and investments that benefit the whole community.</p>

                <p>The Twin Cities Housing Policy Finder tracks local housing affordability, preservation, and protection policies throughout the region. Use this interactive resource to find links to adopted policies and ordinances and learn more about the local policy environment. Family Housing Fund originally developed this resource in 2023, in partnership with Bennett Community Consulting and <a target="_blank" rel="noreferrer" href="https://www.srfconsulting.com/">SRF Consulting (formerly Visible City)</a>. The tool now also includes data from the Metropolitan Council’s annual <a target="_blank" rel="noreferrer" href="https://metrocouncil.org/Housing/Planning/Affordable-Housing-Measures/Housing-Policy-and-Production-Survey.aspx">Housing Policy and Production Survey</a>, with the most recent update reflecting the 2025 survey results.</p>

                <p>Information in the Housing Policy Finder is based on voluntary survey responses from participating local jurisdictions, and inclusion does not represent an endorsement of any policy or ordinance displayed. To date, 4 counties and 85 cities have contributed policy information.</p>
                
                <Button variant="link" onClick={handleAboutClick} className="p-0">
                    Click here for more information about how to use this tool.
                </Button>

            <hr/>
                <div>
                    <h5><b>We Welcome Your Feedback</b></h5>
                    <span>
                    <a target="_blank" rel="noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSeDYIsxs1N6SdyfnbFOS0DmXQdK2YwJkF4yFo2h9PUc_I8lFw/viewform">Please use this link to submit corrections, updates on policies being considered, or additional policies. Thank you!</a>
                    </span>
                </div>
                <hr/>

                <i>Thank you to the City and County representatives who provided the policy-related details that this tool is based on. Last updated December 2025. </i>
            </Modal.Body>
        </Modal>
    );
}

export default PopupModal;

